import { defineStore } from 'pinia'
import api from '@/services/api'
import { setDateTimeTimezone } from '@/services/date-time'
import { setTeamThemeColor } from '@/services/team-theme'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
  }),
  getters: {
    // getters receive the state as the first argument
    isAuthenticated: (state) => !!state.user,
    canManageResources: (state) => Boolean(state.user?.permissions?.manage_resources),
  },
  actions: {
    syncDateTimeTimezone(user) {
      setDateTimeTimezone(user?.current_team_timezone ?? 'UTC')
    },
    syncTeamTheme(user) {
      setTeamThemeColor(user?.current_team_icon_color ?? null)
    },
    async attemptUser() {
      try {
        const response = await api.get('/api/v1/me')
        this.user = response.data.data
        this.syncDateTimeTimezone(this.user)
        this.syncTeamTheme(this.user)
        return response
      } catch (error) {
        this.user = null
        this.syncDateTimeTimezone(null)
        this.syncTeamTheme(null)
        throw error
      }
    },
    async logout() {
      try {
        await api.post('/logout')
        this.user = null
        this.syncDateTimeTimezone(null)
        this.syncTeamTheme(null)
      } catch (error) {
        console.error("error in auth store", error)
        this.user = null
        this.syncDateTimeTimezone(null)
        this.syncTeamTheme(null)
      }
    },
    setUser(user) {
      this.user = user
      this.syncDateTimeTimezone(user)
      this.syncTeamTheme(user)
    }
  },
})
